module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/datagrid/datagrid-header/datagrid-header.component.scss
// module id = ./libs/atenea-cms/src/datagrid/datagrid-header/datagrid-header.component.scss
// module chunks = main